<template>
    <div >
        <div class="form__item">
            <h2 class="title title--s title--uppercase">{{ $lang('auth.title') }}</h2>
            <!--<span class="popup__header-description">Остался последний шаг для добавления видео, текста, фотографий<br> — оплатить полный доступ.</span>-->
        </div>
        <div>
            <errors :errors="errors"></errors>
            <form class="form" @submit.prevent="loginPost">
                <div class="form__item form__item--inline">
                    <label class="form__inner">
                        <span class="form__label">{{ $lang('auth.input.title') }}</span>
                        <el-input class="input input--big" :placeholder="$lang('email.input.placeholder')" v-model="formAuth.login" required dusk="login"></el-input>
                    </label>
                    <label class="form__inner">
                        <span class="form__label">{{ $lang('auth.input2.title') }}</span>
                        <el-input class="input input--big" type="password" placeholder="*******" v-model="formAuth.password" required show-password dusk="password"></el-input>
                    </label>
                </div>
                <div class="create__price-box" v-if="pageType == pageTypes.full">
                    <span class="create__price">{{ price | priceFormat }} {{ prices.currency.symbol }}</span>
                    <span class="create__price-type">{{
                            burial || paymentType === paymentTypes.burial ? $lang('auth.page.burial') : $lang('auth.page.full')
                        }}
                    </span>
                </div>
                <div class="form__item">
                    <button v-if="pageType == pageTypes.short && !user" class="btn btn--middle btn--main-bg">{{ $lang('auth.button2') }}</button>
                    <button v-if="pageType == pageTypes.full && !user" class="btn btn--middle btn--main-bg" dusk="login-checkout">{{ $lang('auth.button3') }}</button>
                </div>
                <div v-if="!user" class="form__item form__item--inline">
                    <span class="popup__auth-hint">{{ $lang('auth.restore.text') }}</span> <button class="btn link" @click.prevent="setType('reset')"><span>{{ $lang('auth.restore.link') }}</span></button>
                </div>
                <div v-if="!user" class="form__item form__item--inline">
                    <span class="popup__auth-hint">{{ $lang('auth.reg.text') }}</span> <button class="btn link" @click.prevent="setType('register')" dusk="registration"><span>{{ $lang('auth.reg.link') }}</span></button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapMutations, mapState } from 'vuex';
    import Errors from "../../error/errors";
    import helper from "../../../mixins/helper";

    export default {
        name: "login",
        components: {Errors},
        mixins:[helper],
        props:['price','pageType', 'burial', 'paymentType'],
        data: () => ({
            errors: null,
            paymentTypes: window.laravel.paymentTypes,
            pageTypes: window.laravel.pageTypes,
            prices: window.laravel.prices,
        }),
        computed: {
            ...mapState('auth',[
                'formAuth',
                'user',
            ]),
            ...mapState('create',[
                'form',
            ])
        },
        methods: {
            ...mapMutations('create', [
                'setType',
            ]),
            ...mapMutations('auth', [
                'clearData',
                'setUser'
            ]),
            ...mapActions('auth', [
                'login',
            ]),
            loginPost(){
                this.phoneFormatted();

                this.$loading(this.$optionsLoading);

                this.login().then((response) => {
                    this.setUser(response.data.user);

                    this.$emit('create:page', response.data.user);
                }).catch((error) => {
                    this.errors = error.response.data.errors;
                }).finally(() => {
                    this.$loading({}).close();
                });
            },
        },
        beforeDestroy() {
            this.$nextTick(() => {
                this.clearData();
            });
        },
    }
</script>

<style scoped>

</style>
